export default __webpack_public_path__ + "static/media/h100-3.03170fd4.png";